import { parseApiProduct } from "../parse/product";

/**
 * Converts product data to a keyed object format for Redux store
 * @param {Array|Object} unMappedData - Backend product data (single, array, or keyed object)
 * @returns {Object} Products keyed by their ID
 */
export const mapProductData = (unMappedData) => {
  if (!unMappedData) return {};

  // Handle single backend product
  if (unMappedData.id || unMappedData.Id) {
    const id = unMappedData.id || unMappedData.Id;
    const parsed = parseApiProduct(unMappedData);
    return parsed ? { [id]: parsed } : {};
  }

  // Handle array of backend products
  if (Array.isArray(unMappedData)) {
    return unMappedData.reduce((acc, product) => {
      const id = product.id || product.Id;
      if (id) {
        const parsed = parseApiProduct(product);
        if (parsed) {
          acc[id] = parsed;
        }
      }
      return acc;
    }, {});
  }

  // Handle object of backend products (already keyed by ID)
  if (typeof unMappedData === "object") {
    // Check if it's already an object of products keyed by ID
    const firstKey = Object.keys(unMappedData)[0];
    if (firstKey && (unMappedData[firstKey].id || unMappedData[firstKey].Id)) {
      // Parse each product in the object
      const result = {};
      Object.keys(unMappedData).forEach((key) => {
        const parsed = parseApiProduct(unMappedData[key]);
        if (parsed) {
          result[key] = parsed;
        }
      });
      return result;
    }
  }

  return {};
};

export const mapProductComparisonTableDatum = (data, included) => {
  // This function is for JSON:API format - kept for backward compatibility
  // as it's still referenced in the reducer for fetchComparisonTableSuccess
  if (!data || !data.relationships) {
    console.warn("mapProductComparisonTableDatum expects JSON:API format data");
    return { apis: [], productNames: [], table: null };
  }

  const comparisonTable = data.relationships?.field_comparison_row?.data || [];
  const productNames = data.attributes?.field_custom_title || [];
  const comparisonApis =
    data.relationships?.field_product?.data?.map((api) => api.id) || [];

  return {
    apis: comparisonApis,
    productNames: productNames,
    table: comparisonTable,
  };
};
